import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/pro-solid-svg-icons/faGlobe";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@wondermaps/ui";
import type { SupportedLanguage } from "../../i18n/config";

const LANGUAGES: SupportedLanguage[] = ["en", "es", "fr"];

interface LanguagePickerProps {
  /** Restrict to a subset of languages (org config). Defaults to all supported. */
  availableLanguages?: SupportedLanguage[];
}

export function LanguagePicker({
  availableLanguages,
}: LanguagePickerProps) {
  const { t, i18n } = useTranslation("common");
  const languages = availableLanguages ?? LANGUAGES;

  const handleChange = (lang: string) => {
    i18n.changeLanguage(lang);
    // Update ?lang= param without reload
    const url = new URL(window.location.href);
    url.searchParams.set("lang", lang);
    window.history.replaceState({}, "", url.toString());
  };

  return (
    <div className="flex items-center gap-2 px-4 py-2">
      <FontAwesomeIcon icon={faGlobe} className="h-4 w-4 text-muted-foreground shrink-0" />
      <Select value={i18n.language} onValueChange={handleChange}>
        <SelectTrigger className="h-10 text-sm flex-1">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {languages.map((lang) => (
            <SelectItem key={lang} value={lang}>
              {t(`language.${lang}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
